import { render, staticRenderFns } from "./LabsModal.vue?vue&type=template&id=3894c3f8"
import script from "./LabsModal.vue?vue&type=script&lang=js"
export * from "./LabsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports